import { Button } from "../components/Button";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

export function LookingForScreen() {
  const { answers, setLookingFor, next, canContinue } = useFlow();
  const t = useT();

  return (
    <>
      <div className="prompt screen-enter">
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("looking.eyebrow")}</div>
          <h1 className="screen-head__title">{t("looking.title")}</h1>
          <p className="screen-head__text">{t("looking.text")}</p>
        </header>
        <label className="field">
          <span className="sr-only">{t("looking.label")}</span>
          <textarea
            className="field__textarea"
            rows={6}
            maxLength={600}
            placeholder={t("looking.placeholder")}
            value={answers.lookingFor}
            onChange={(e) => setLookingFor(e.target.value)}
          />
        </label>
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("common.next")}
        </Button>
      </div>
    </>
  );
}
